import api from './api';
import {setToken} from './servicesGetCookie';

export const SaveMyProfile = async (objDadosProfile)=>{
    const AUTH_TOKEN = setToken();
    const resposta = await api.post(`saveMyProfile`,{
        Name:objDadosProfile.Nome,
        Email:objDadosProfile.Email,
        Cover:objDadosProfile.Cover,
        Picture:objDadosProfile.Image1,
        OfficeEmail:objDadosProfile.EmailConsultorio,
        OfficePhone1:objDadosProfile.Telefone,
        OfficePhone2:objDadosProfile.Telefone2,
        ResumeText:objDadosProfile.Curriculo,
        AliasName:objDadosProfile.NomeBlog,
        AliasFolder:objDadosProfile.EnderecoBlog,
        Instagram:objDadosProfile.Instagram,
        Facebook:objDadosProfile.FanpageFacebook,
        Youtube:objDadosProfile.Youtube,
        Keywords:objDadosProfile.PalavraGoogle,
        Description:objDadosProfile.Description,
        DescriptionWelcome:objDadosProfile.DescriptionWelcome,
        DescriptionPage1:objDadosProfile.DescriptionPage1,//.replace(/\n/g,'<br/>'),
        DescriptionPage2:objDadosProfile.DescriptionPage2,//.replace(/\n/g,'<br/>'),
        Menu1:objDadosProfile.SliderCaption2.toUpperCase(),
        Menu2:objDadosProfile.SliderCaption3.toUpperCase(),
        SliderCaption1:objDadosProfile.SliderCaption1,
        SliderCaption2:objDadosProfile.SliderCaption2.toUpperCase(),
        SliderCaption3:objDadosProfile.SliderCaption3.toUpperCase(),
        SliderDescription1:objDadosProfile.SliderDescription1,
        SliderDescription2:objDadosProfile.SliderDescription2,
        SliderDescription3:objDadosProfile.SliderDescription3,
        SliderPicture1:objDadosProfile.SliderPicture1,
        SliderPicture2:objDadosProfile.SliderPicture2,
        SliderPicture3:objDadosProfile.SliderPicture3,
        LogoHeader:objDadosProfile.LogoHeader,
        LogoMobile:objDadosProfile.LogoMobile,
        City1:objDadosProfile.City1,
        City2:objDadosProfile.City2,
        Address1:objDadosProfile.Address1,
        Address2:objDadosProfile.Address2,
        AnalyticsCode:objDadosProfile.AnalyticsCode,
        NewsLetterLink:objDadosProfile.NewsLetterLink

    },{'headers':{'Authorization':`Bearer ${AUTH_TOKEN}`}}).then((response)=>{
        return response
    }).catch((error)=>{

          return  error.response;

    })

    return resposta;
}
